import React, {createContext, useEffect, useReducer} from "react";
import PropTypes from "prop-types";
import LocalizedReducer from "../reducers/localizedReducer";
import {useLocalizedContent} from "../../hooks/useLocalizedContent";
import {SUPPORTED_LANGUAGE} from "../../common/i18n/locales/localeConstant";
import {cloneObject} from "../../common/common";

const initialState = {
    idsMap: {
    },
    slugsMap: {
    }
};

export const CATEGORIES = {
    COUNTRIES: "countries",
    DESTINATIONS: "destinations",
    RESORTS: "resorts",
    PAGES: "pages"
};

const LocalizedProvider = ({children}) => {
    const {data} = useLocalizedContent();

    const slugStructure = {};
    Object.entries(CATEGORIES).forEach((category) => {
        slugStructure[category[1]] = {};
    });

    Object.entries(SUPPORTED_LANGUAGE).forEach((language) => {
        initialState.slugsMap[language[1]] = JSON.parse(JSON.stringify(slugStructure));
    });

    const [localizedState, localizedDispatch] = useReducer(LocalizedReducer, initialState);

    useEffect(() => {
        if (data) {
            populateIdsMap(data.countryCollection.items);
            populateIdsMap(data.destinationCollection.items);
            populateIdsMap(data.resortCollection.items);
            populateIdsMap(data.pageCollection.items);

            populateSlugsMap(data.countryCollection.items, CATEGORIES.COUNTRIES);
            populateSlugsMap(data.destinationCollection.items, CATEGORIES.DESTINATIONS);
            populateSlugsMap(data.resortCollection.items, CATEGORIES.RESORTS);
            populateSlugsMap(data.pageCollection.items, CATEGORIES.PAGES);
        }
    }, [data]);

    const populateIdsMap = (entries) => {
        entries.forEach((entry) => {
            const clonedEntry = cloneObject(entry);
            Object.keys(clonedEntry).forEach((e) => {
                if (typeof clonedEntry[e] === "string") {
                    if (clonedEntry[e][0] === "/") {
                        clonedEntry[e] = clonedEntry[e].substring(1);
                    }
                }
            });
            initialState.idsMap[clonedEntry.sys.id] = clonedEntry;
        });
    };

    const populateSlugsMap = (entries, category) => {
        entries.forEach((entry) => {
            Object.entries(SUPPORTED_LANGUAGE).forEach((language) => {
                if(entry["slug_" + language[1].replace("-", "_")]) {
                    let slug = entry["slug_" + language[1].replace("-", "_")].replace("_", "-");
                    if (slug[0] === "/") {
                        slug = slug.substring(1);
                    }
                    initialState.slugsMap[language[1]][category][slug] = entry.sys.id;
                }
            });
        });
    };

    return (
        <LocalizedContext.Provider value={[localizedState, localizedDispatch]}>
            {children}
        </LocalizedContext.Provider>
    );
};

LocalizedProvider.propTypes = {
    children: PropTypes.any
};

export const LocalizedContext = createContext(initialState);
export default LocalizedProvider;
